/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Rosy_Hawk_WalkInputs */

const en_kind_rosy_hawk_walk = /** @type {(inputs: Kind_Rosy_Hawk_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveys`)
};

const de_kind_rosy_hawk_walk = /** @type {(inputs: Kind_Rosy_Hawk_WalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungen`)
};

/**
* | output |
* | --- |
* | "Surveys" |
*
* @param {Kind_Rosy_Hawk_WalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_rosy_hawk_walk = /** @type {((inputs?: Kind_Rosy_Hawk_WalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Rosy_Hawk_WalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_rosy_hawk_walk(inputs)
	return de_kind_rosy_hawk_walk(inputs)
});